import { render } from "./UiToggle.vue?vue&type=template&id=53b346a1&scoped=true"
import script from "./UiToggle.vue?vue&type=script&lang=js"
export * from "./UiToggle.vue?vue&type=script&lang=js"

import "./UiToggle.vue?vue&type=style&index=0&id=53b346a1&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b346a1"]])

export default __exports__